'use client';

import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

export default function ServicesHeroHeader() {
  return (
    <section
      className="pt-28 pb-16 px-4 sm:px-6 relative overflow-hidden"
      style={{ background: 'linear-gradient(135deg,#0D1B3E 0%,#1877F2 70%,#162550 100%)' }}>

      {/* Decorative */}
      <div
        className="absolute top-0 right-0 w-96 h-96 rounded-full pointer-events-none"
        style={{
          background: 'radial-gradient(circle,rgba(244,169,35,0.12) 0%,transparent 70%)',
          transform: 'translate(30%,-30%)'
        }} />

      <div
        className="absolute bottom-0 left-0 w-72 h-72 rounded-full pointer-events-none"
        style={{
          background: 'radial-gradient(circle,rgba(255,255,255,0.04) 0%,transparent 70%)',
          transform: 'translate(-30%,30%)'
        }} />

      <div className="max-w-7xl mx-auto relative z-10">
        {/* Breadcrumb */}
        <div className="flex items-center gap-2 text-white/50 text-xs mb-6">
          <Link href="/homepage" className="hover:text-white transition-colors">
            Accueil
          </Link>
          <Icon name="ChevronRightIcon" size={12} className="text-white/30" />
          <span className="text-white/80">Services & Tarifs</span>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          <div>
            <div
              className="inline-flex items-center gap-2 px-4 py-2 rounded-full mb-5"
              style={{ background: 'rgba(244,169,35,0.15)', border: '1px solid rgba(244,169,35,0.3)' }}>

              <span className="w-2 h-2 rounded-full bg-[#F4A923] animate-pulse" />
              <span className="text-[#F4A923] text-xs font-bold tracking-widest uppercase">
                Tarifs transparents · Livraison garantie
              </span>
            </div>

            <h1
              className="font-heading font-black text-white mb-4"
              style={{ fontSize: 'clamp(2rem,5vw,3.5rem)', lineHeight: 1.05 }}>

              Choisissez votre
              <br />
              <span
                style={{
                  background: 'linear-gradient(135deg,#F4A923,#F7C05A)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text'
                }}>

                pack de croissance
              </span>
            </h1>

            <p className="text-white/65 mb-6 max-w-lg" style={{ fontSize: 15, lineHeight: 1.7 }}>Des abonnés, likes et commentaires  livrés rapidement. Paiement en XOF via Orange Money, MTN MoMo ou Wave.

            </p>

            {/* Quick stats */}
            <div className="flex flex-wrap gap-5">
              {[
              { n: '12 500+', l: 'Commandes' },
              { n: '< 24h', l: 'Livraison' },
              { n: '4.9★', l: 'Note' }]?.
              map((s) =>
              <div key={s?.l}>
                  <div className="text-white font-heading font-bold text-xl">{s?.n}</div>
                  <div className="text-white/45 text-xs">{s?.l}</div>
                </div>
              )}
            </div>
          </div>

          {/* Right: Payment methods highlight */}
          <div className="hidden lg:block">
            <div
              className="rounded-3xl p-7"
              style={{ background: 'rgba(255,255,255,0.08)', border: '1px solid rgba(255,255,255,0.12)' }}>

              <div className="text-white/60 text-xs font-bold uppercase tracking-wider mb-4">
                🇨🇮 Méthodes de paiement acceptées
              </div>
              <div className="space-y-3">
                {[
                { emoji: '🟠', label: 'Orange Money CI', desc: 'Paiement instantané', color: '#FF6600' },
                { emoji: '🟡', label: 'MTN MoMo', desc: 'Mobile Money', color: '#FFCC00' },
                { emoji: '🔵', label: 'Wave', desc: 'Sans frais supplémentaires', color: '#1ABCFE' },
                { emoji: '💳', label: 'Carte Bancaire', desc: 'Visa / Mastercard', color: '#fff' }]?.
                map((pm) =>
                <div
                  key={pm?.label}
                  className="flex items-center gap-3 p-3 rounded-2xl"
                  style={{ background: 'rgba(255,255,255,0.06)' }}>

                    <div
                    className="w-10 h-10 rounded-xl flex items-center justify-center text-lg flex-shrink-0"
                    style={{ background: `${pm?.color}25` }}>

                      {pm?.emoji}
                    </div>
                    <div>
                      <div className="text-white text-sm font-semibold">{pm?.label}</div>
                      <div className="text-white/40 text-xs">{pm?.desc}</div>
                    </div>
                    <Icon
                    name="CheckCircleIcon"
                    size={18}
                    variant="solid"
                    className="ml-auto text-[#10B981]" />

                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Bottom wave */}
      <div className="absolute bottom-0 left-0 w-full overflow-hidden leading-none" style={{ height: 50 }}>
        <svg
          viewBox="0 0 1440 50"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          preserveAspectRatio="none"
          style={{ width: '100%', height: '100%' }}>

          <path d="M0 50 L0 25 Q360 0 720 25 Q1080 50 1440 25 L1440 50 Z" fill="#F4F6FB" />
        </svg>
      </div>
    </section>);

}